export default "__VITE_ASSET__BTkYB7KL__"